import * as actions from '../../actions/actionTypes';
//
const initialState = [];
//
export default function ch0104(state = initialState, action) {
  switch (action.type) {
    case actions.SET_CH0104_SUCCESS:
      if (action.payload) {
        return action.payload;
      } else {
        return state;
      }
    case actions.SET_CH0104_FAILURE:
      return state;
    default:
      return state;
  }
}
